import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../../core';
import { ClienteCentralCompraParticipante } from '../cliente-central-compra-participante';

@Injectable({
    providedIn: 'root'
})
export class ClienteCentralCompraParticipanteHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientecentralcompra`;
    }

    /** Pesquisa os clientes participantes da central de compras */
    search(idClienteCentralCompra: number): Observable<ClienteCentralCompraParticipante[]> {
        return this.customHttp.get<ClienteCentralCompraParticipante[]>(`${this.pathApi}/${idClienteCentralCompra}/participantes`);
    }
}
